import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SUPERGET, SUPERPOST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchDataUser = createAsyncThunk(
  "UserDetail/fetchDataUser",
  async ({ key, UserName, password }, { rejectWithValue }) => {

    var requestData = CustomStringify({
      user_name: UserName,
      password: password,
    });

    try {
      const result = await SUPERPOST(`/sellers/lgnvndr/${key}`, requestData);
      return result;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const UserDetailSlice = createSlice({
  name: "UserDetail",
  initialState: {
    result: {},
    status: "idle",
    error: null,
  },
  reducers: {
    editUserDetail: (state, action) => {
      return state = { ...state, result: { ...state.result, user: { ...state.result?.user, [action?.payload?.name]: action?.payload?.value } } }
    },
    removeUserDetail: (state, action) => {
      return state = {
        result: {},
        status: "idle",
        error: null,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDataUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action?.payload ? {
          ...action?.payload,
          user: {
            ...action?.payload?.user,
            vendor_barcode_formate: action?.payload?.user?.vendor_barcode_formate || "38x25"
          }
        }
          : {};
      })
      .addCase(fetchDataUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { editUserDetail, removeUserDetail } = UserDetailSlice.actions;

export default UserDetailSlice.reducer;
